import { initializeApp } from "firebase/app";
import { isSupported, getMessaging, getToken, onMessage } from "firebase/messaging";

export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const FIREBASE_VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

const app = initializeApp(firebaseConfig);
let messagingPromise = isSupported().then((supported) => {
    if (supported) {
        const messaging = getMessaging(app);
        onMessage(messaging, ({ notification }) => {
            new Notification(notification?.title || "New Message", {
                body: notification?.body,
                icon: notification?.icon,
            });
        });
        return messaging;
    } else {
        console.warn("Firebase Messaging is not supported in this browser.");
        return null;
    }
});

// Register service worker
export const registerServiceWorker = async () => {
    if ("serviceWorker" in navigator) {
        try {
            const swPath = `${process.env.PUBLIC_URL || "/admin"}/firebase-messaging-sw.js`;
            const registration = await navigator.serviceWorker.register(swPath);
            console.info("✅ Service Worker registered:", registration);
            return registration;
        } catch (error) {
            console.error("❌ Service Worker registration failed:", error);
            return null;
        }
    } else {
        console.error("❌ Service Worker not supported in this browser.");
        return null;
    }
};

export const requestForToken = async () => {
    try {
        if (
            typeof Notification === "undefined" ||
            !window.isSecureContext ||
            !("serviceWorker" in navigator) ||
            Notification.permission !== "granted"
        ) {
            return null;
        }

        const messaging = await messagingPromise;
        if (!messaging) return null;

        const swPath = `${process.env.PUBLIC_URL || "/admin"}/firebase-messaging-sw.js`;
        let registration = await navigator.serviceWorker.getRegistration(swPath);
        
        if (!registration) {
            registration = await registerServiceWorker();
        }

        if (!registration) {
            console.error("❌ Could not get Service Worker registration");
            return null;
        }

        const currentToken = await getToken(messaging, { 
            vapidKey: FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: registration
        });

        if (currentToken) {
            return currentToken;
        } else {
            console.warn("No registration token available. Request permission to generate one.");
            return null;
        }
    } catch (err) {
        if (err?.code === "messaging/permission-blocked") {
            return null;
        }
        console.error("An error occurred while retrieving token - ", err);
        return null;
    }
};
 